const { apiConfig } = window["runtimeConfig"];

const config = {
  baseUrl: apiConfig.baseUrl,
};

export default config;
